import React, { useState } from 'react';

const sectors = [
  'Padel & Sport', 'Coworking', 'Café & Lounge',
  'Hammam & Spa', 'Salle de sport', 'E-commerce', 'Autre',
];

export default function Contact() {
  const [form, setForm] = useState({ nom: '', email: '', typeBusiness: '', projet: '', codePromo: '' });
  const [status, setStatus] = useState('idle');

  const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    setStatus('loading');
    try {
      const res = await fetch('https://softyclient-production.up.railway.app/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setStatus('success');
        setForm({ nom: '', email: '', typeBusiness: '', projet: '', codePromo: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const inputStyle = {
    width: '100%', background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 10, padding: '12px 16px',
    color: '#fff', fontSize: 15,
    fontFamily: 'Inter, sans-serif',
    outline: 'none', transition: 'border-color 0.2s',
    boxSizing: 'border-box',
  };

  const perks = [
    { icon: '⚡', title: 'Réponse rapide', sub: 'Retour garanti sous 24h ouvrées' },
    { icon: '🔒', title: 'Vos données sont sécurisées', sub: 'Informations confidentielles, jamais partagées' },
    { icon: '💬', title: 'Devis gratuit', sub: 'Estimation sans engagement ni surprise' },
    { icon: '🇲🇦', title: 'Basé au Maroc', sub: 'Facturation locale, support en darija & français' },
  ];

  return (
    <section id="contact" style={{
      background: '#0d0d14', padding: '7rem 2rem',
    }}>
      <div style={{
        maxWidth: 1100, margin: '0 auto',
        display: 'grid', gridTemplateColumns: '1fr 1.2fr',
        gap: '4rem', alignItems: 'start',
      }} className="contact-grid">
        {/* Left */}
        <div>
          <p style={{
            color: '#7C3AED', fontWeight: 600, fontSize: 12,
            letterSpacing: '0.15em', textTransform: 'uppercase',
            marginBottom: '1rem',
          }}>CONTACT</p>
          <h2 style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 800,
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            lineHeight: 1.1, letterSpacing: '-0.02em',
            marginBottom: '1.5rem',
          }}>
            Démarrez <span style={{ color: '#A78BFA' }}>votre projet</span>
          </h2>
          <p style={{ color: '#8b8b9a', fontSize: 16, lineHeight: 1.7, marginBottom: '2.5rem' }}>
            Remplissez le formulaire et nous vous répondons sous{' '}
            <strong style={{ color: '#fff' }}>24h ouvrées</strong>.
            Pas de commercial agressif — juste une vraie conversation sur votre projet.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
            {perks.map((pk, i) => (
              <div key={i} style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                <div style={{
                  width: 38, height: 38, borderRadius: 10,
                  background: 'rgba(124,58,237,0.15)',
                  display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: 18, flexShrink: 0,
                }}>{pk.icon}</div>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 2 }}>{pk.title}</div>
                  <div style={{ color: '#8b8b9a', fontSize: 13 }}>{pk.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Form */}
        <div style={{
          background: '#13131d',
          border: '1px solid rgba(124,58,237,0.15)',
          borderRadius: 20, padding: '2.5rem',
        }}>
          {status === 'success' ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{ fontSize: 48, marginBottom: '1rem' }}>✅</div>
              <h3 style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '1.3rem', fontWeight: 700, marginBottom: '0.75rem' }}>
                Demande envoyée !
              </h3>
              <p style={{ color: '#8b8b9a' }}>Nous vous contactons sous 24h ouvrées.</p>
              <button onClick={() => setStatus('idle')} style={{
                marginTop: '1.5rem', background: 'rgba(124,58,237,0.15)',
                border: '1px solid rgba(124,58,237,0.3)',
                color: '#A78BFA', padding: '10px 24px',
                borderRadius: 8, cursor: 'pointer', fontSize: 14,
              }}>Envoyer une autre demande</button>
            </div>
          ) : (
            <form onSubmit={onSubmit}>
              <h3 style={{
                fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '1.2rem',
                fontWeight: 700, marginBottom: '1.5rem',
              }}>Parlez-nous de votre projet</h3>

              <div className="form-grid" style={{
                display: 'grid', gridTemplateColumns: '1fr 1fr',
                gap: '1rem', marginBottom: '1rem',
              }}>
                <div>
                  <label style={{ fontSize: 12, color: '#8b8b9a', fontWeight: 500, display: 'block', marginBottom: 6 }}>
                    NOM COMPLET *
                  </label>
                  <input
                    name="nom" value={form.nom} onChange={onChange}
                    placeholder="Nom Prénom" required
                    style={inputStyle}
                    onFocus={e => e.target.style.borderColor = '#7C3AED'}
                    onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                  />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: '#8b8b9a', fontWeight: 500, display: 'block', marginBottom: 6 }}>
                    EMAIL *
                  </label>
                  <input
                    name="email" type="email" value={form.email} onChange={onChange}
                    placeholder="you@example.com" required
                    style={inputStyle}
                    onFocus={e => e.target.style.borderColor = '#7C3AED'}
                    onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                  />
                </div>
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ fontSize: 12, color: '#8b8b9a', fontWeight: 500, display: 'block', marginBottom: 6 }}>
                  TYPE DE BUSINESS *
                </label>
                <select
                  name="typeBusiness" value={form.typeBusiness} onChange={onChange} required
                  style={{ ...inputStyle, cursor: 'pointer' }}
                  onFocus={e => e.target.style.borderColor = '#7C3AED'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                >
                  <option value="" style={{ background: '#13131d' }}>Sélectionnez votre secteur...</option>
                  {sectors.map(s => (
                    <option key={s} value={s} style={{ background: '#13131d' }}>{s}</option>
                  ))}
                </select>
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ fontSize: 12, color: '#8b8b9a', fontWeight: 500, display: 'block', marginBottom: 6 }}>
                  VOTRE PROJET *
                </label>
                <textarea
                  name="projet" value={form.projet} onChange={onChange}
                  placeholder="Décrivez votre activité, vos besoins, vos délais..."
                  required rows={4}
                  style={{ ...inputStyle, resize: 'vertical', minHeight: 100 }}
                  onFocus={e => e.target.style.borderColor = '#7C3AED'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                />
              </div>

              {status === 'error' && (
                <p style={{ color: '#ef4444', fontSize: 14, marginBottom: '1rem' }}>
                  Une erreur est survenue. Réessayez.
                </p>
              )}
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ fontSize: 12, color: '#8b8b9a', fontWeight: 500, display: 'block', marginBottom: 6 }}>
               CODE PROMO
              </label>
  <input
    name="codePromo" value={form.codePromo} onChange={onChange}
    placeholder="Ex: LAUNCH50"
    style={inputStyle}
    onFocus={e => e.target.style.borderColor = '#7C3AED'}
    onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
  />
</div>
              <button type="submit" disabled={status === 'loading'} style={{
                width: '100%', background: '#7C3AED',
                color: '#fff', padding: '14px',
                borderRadius: 10, border: 'none',
                fontSize: 16, fontWeight: 700,
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                cursor: status === 'loading' ? 'not-allowed' : 'pointer',
                opacity: status === 'loading' ? 0.7 : 1,
                transition: 'all 0.2s',
              }}
                onMouseEnter={e => { if (status !== 'loading') e.currentTarget.style.background = '#6D28D9'; }}
                onMouseLeave={e => e.currentTarget.style.background = '#7C3AED'}
              >
                {status === 'loading' ? 'Envoi en cours...' : 'Démarrer mon projet →'}
              </button>

              <p style={{ textAlign: 'center', color: '#4a4a5a', fontSize: 12, marginTop: '1rem' }}>
                En soumettant, vous acceptez d'être contacté par SoftyPusher.
              </p>
            </form>
            
          )}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .contact-grid { grid-template-columns: 1fr !important; gap: 2rem !important; }
          .form-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}